/* src/app/private/configrations/academic-year-configuration/academic-year-configuration.component.scss */
.no-data {
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  padding: 20px;
}
.action-button {
  color: var(--primary-color);
  cursor: pointer;
  margin-left: 10px;
}
/*# sourceMappingURL=academic-year-configuration.component.css.map */
